<section
  class="w-600 h-300 modal d-flex direction-column p-25 justify-space-between"
>
  <ng-container [formGroup]="form">
    <div class="modal-header"><span mat-dialog-title>Adicionar configuração</span></div>
    <div class="modal-body d-flex column-gap-20 vw-100">
      <div class="d-flex direction-column flex-1">
        <span>Canal de Vendas:</span>
        <app-c-select
          width="100%"
          height="40px"
          placeholder="Selecione"
          alignItem="flex-start"
          formControlName="Channel"
          [data]="channelOpts"
        ></app-c-select>
      </div>
    </div>
    <div class="modal-footer footer vw-100 d-flex column-gap-50">
      <button type="button" class="flex-1 footer-back ui-btn ui-btn--secondary" mat-dialog-close>
        Voltar
      </button>
      <button
        [disabled]="form.invalid"
        type="button"
        class="flex-1 footer-save ui-btn ui-btn--primary"
        (click)="handleAddConfig()"
      >
        Cadastrar configuração
      </button>
    </div>
  </ng-container>
</section>
